"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // CMS Biz Objectives
  CREATE_ENGAGING_CONTENT: 'createEngagingContent',
  PERSONALIZE_EXPERIENCES: 'personalizeExperiences',
  GET_FOUND_ONLINE_CMS: 'getFoundOnlineCms',
  CAPTURE_CONVERT_LEADS_CMS: 'captureAndConvertLeadsCms',
  // Marketing Biz Objectives
  CAPTURE_CONVERT_LEADS_MARKETING: 'captureAndConvertLeadsMarketing',
  ENGAGE_LEADS: 'engageYourLeads',
  UNDERSTAND_LEADS: 'understandYourLeads',
  AUTOMATE_MARKETING: 'automateAndPersonalizeYourMarketing',
  GET_FOUND_ONLINE_MARKETING: 'getFoundOnlineMarketing',
  OPTIMIZE_CONVERSION: 'optimizeConversionRates',
  MEASURE_REVENUE: 'measureRevenue',
  MANAGE_TEAMS_AND_BRANDS: 'manageYourTeamsAndBrands',
  EXTEND_PLATFORM: 'extendPlatform',
  ANALYZE_FULL_CONTROL: 'analyzeFullControl',
  // Sales Biz Objectives
  STREAMLINE_OUTREACH: 'streamlineYourOutreach',
  CONNECT_WITH_PROSPECTS: 'connectWithProspects',
  TRACK_ITERATE_IMPROVE: 'trackIterateAndImprove',
  AUTOMATE_SALES_PROCESS: 'automateYourSalesProcess',
  PERSONALIZE_OUTREACH: 'personalizeYourOutreach',
  KEEP_DATA_ORGANIZED: 'keepYourDataOrganized',
  COACH_AND_ENABLE: 'coachAndEnableAtScale',
  CLOSE_MORE_DEALS: 'closeMoreDealsFaster',
  MANAGE_GROWING_TEAM: 'manageYourGrowingTeam',
  // Service Biz Objectives
  TRACK_CUSTOMER_COMMS: 'organizeAndTrackCustomerCommunications',
  MAXIMIZE_PRODUCTIVITY: 'maximizeProductivity',
  MEASURE_EFFICIENCY: 'measureEfficiency',
  DELIGHT_CUSTOMERS: 'delightCustomersAtScale',
  HELP_CUSTOMERS_HELP_THEMSELVES: 'helpCustomersHelpThemselves',
  MEASURE_IMPROVE_CUSTOMER_EXPERIENCE: 'measureImproveCustomerExperience',
  DELIVER_EXCEPTIONAL_SERVICE: 'deliverExceptionalService',
  MANAGE_MULTIPLE_TEAMS: 'manageMultipleTeamsAndBusinesses',
  ENABLE_SELF_SERVICE: 'enableSelfServiceAtScale'
};
exports.default = _default;
module.exports = exports.default;